import {MenuItem} from "pages/main/menu/MenuItem"

export const Menu = () => {
    return (
        <div className="menu-left">
            <div className="menu1 mt50">
                <nav>
                    <div className="border border-sky-100 rounded-md mb-5">
                        <MenuItem linkTo="role/list" name="Roles" icon="fa-layer-group"/>
                        <MenuItem linkTo="group/list" name="Groups" icon="fa-users"/>
                        <MenuItem linkTo="user/list" name="Users" icon="fa-user"/>
                        <MenuItem linkTo="message-route/list" name="Route" icon="fa-route"/>
                    </div>
                    {/*<div className="border border-sky-100 rounded-md">*/}
                    {/*<MenuItem linkTo="group/list" name="Groups" icon="fa-users"/>*/}
                    {/*<MenuItem linkTo="user/list" name="Users" icon="fa-user"/>*/}
                    {/*</div>*/}
                    <div className="menu-bn mt30">
                        <div className="cursor-pointer"><img src="/img/img-bn.png" alt=""/></div>
                    </div>
                </nav>
            </div>
        </div>
    )
}